import { render, staticRenderFns } from "./VeJwKsArrange.vue?vue&type=template&id=33044e96&scoped=true"
import script from "./VeJwKsArrange.vue?vue&type=script&lang=js"
export * from "./VeJwKsArrange.vue?vue&type=script&lang=js"
import style0 from "./VeJwKsArrange.vue?vue&type=style&index=0&id=33044e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33044e96",
  null
  
)

export default component.exports